import {useState, useEffect, useContext} from 'react';
import ErrorContext from "../contexts/error/ErrorContext";
import Toasts, {TOAST_ERROR} from "../../bootstrap/scomponents/toasts/Toasts";
import Request from "../../bootstrap/api/Request";

export default function useRecord(ListParcel, idOrSlug, refNames = []) {
    const [isLoading, setIsLoading] = useState(true);

    const [record, setRecord] = useState(null);

    const [refs, setRefs] = useState({});

    const errorContext = useContext(ErrorContext);

    const filters = [];

    const filtersConfig = {};

    if ('number' === typeof idOrSlug) {
        filters.push({field: 'id', operator: '=', value: idOrSlug});
        filtersConfig.id = {type: 'number'};
    }
    else {
        filters.push({field: 'slug', operator: '=', value: idOrSlug});
        filtersConfig.slug = {type: 'string'};
    }

    const orders = [];

    const limit = 1;

    const offset = 0;

    useEffect(() => {
        Request.add(new ListParcel({filters, filtersConfig, orders, limit, offset, refNames}))
            .then(data => {
                if (data.items.length === 0) {
                    errorContext.setError('NotFound');
                    return;
                }

                setRecord(data.items[0]);

                if (data.refs) {
                    setRefs(data.refs);
                }
            })
            .catch(error => {
                Toasts.add(TOAST_ERROR, error.getMessage());
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return [record, refs, isLoading];
}
